module.exports = __webpack_public_path__ + "img/experian-logo.de798ca9.png";